import { postGenericDocuments } from '@zurich/api/document';
import { useApi, useTranslation } from '@zurich/common/hooks';

// TODO: Use app API endpoint instead of data service endpoint
export function usePostVSGAPhoto() {
  const { t } = useTranslation();

  return useApi({
    request: postGenericDocuments,
    options: {
      errorText: t('vsga:postVSGAEndPoint.error'),
    },
  });
}
